import { Pipe, PipeTransform } from '@angular/core';
import { SystemWorkOrderStatus, WorkOrderStatus, WorkOrderStatusUtility } from '@jms/model';

export enum StatusColorType {
    Foreground = 'fg',
    Background = 'bg'
}

@Pipe({
    name: 'statusColorPipe',
    pure: true,
    standalone: true
})
export class StatusColorPipe implements PipeTransform {

    transform(value: WorkOrderStatus | SystemWorkOrderStatus | string, colorType: StatusColorType | string = StatusColorType.Background): string {
        if (!value) return 'transparent';
        const status = value['name']
            ? (<WorkOrderStatus>value).systemStatus
            : value as SystemWorkOrderStatus;

        const color = colorType === StatusColorType.Background
            ? WorkOrderStatusUtility.getSystemColor(status)
            : WorkOrderStatusUtility.getSystemTextColor(status);

        return color;

    }
}
